export default "__VITE_ASSET__B4eH9hDr__"